import styled from '@emotion/styled';
import { RateCell } from './TabelRowRateCells';
import { BaseRow as Row } from 'shared/containers';

const BaseRow = styled(Row)`
  color: ${props => props.theme.primaryFontColor};
  background-color: ${props => props.theme.cardColor};
  margin-bottom: 8px;
  border: none;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.16);

  @media ${props => props.theme.aboveMobile} {
    &:hover {
      ${RateCell} {
        color: ${props => props.theme.primaryColor};
        font-weight: 800;
      }
      svg {
        fill: ${props => props.theme.highlightColor};
      }
    }
  }
`;

export default BaseRow;
